import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { intlShape, injectIntl } from 'react-intl';
import { Label, TextField, ToggleSwitch, Icon } from 'mw-style-react';
import AppUtils from '@control-front-end/utils/utils';
import mes from './intl';
import BaseItem from './Items/BaseItem';
import './FormEdit.scss';

class FormEdit extends Component {
  // Ф-ция локализации
  i(mesId, values) {
    return AppUtils.getMes(this.context)(mesId, values);
  }

  // Установить индексы в модель
  setItemIndex(items, sectionIndex) {
    items.forEach((item, index) => {
      item.itemIndex = index;
      item.sectionIndex = sectionIndex;
    });
    return items;
  }

  // Групировка элементов формы в строку
  groupRowItems(items) {
    const newItems = [];
    const addedRows = [];
    items.forEach((item) => {
      const rowId = item.row;
      if (!rowId) {
        newItems.push(item);
      } else if (!addedRows.includes(rowId)) {
        const rowItems = items.filter((i) => i.row === rowId);
        newItems.push({
          class: 'row',
          id: `row_${rowId}`,
          items: rowItems,
          rowCount: rowItems.length,
        });
        addedRows.push(rowId);
      }
    });
    return newItems;
  }

  // Отрисовать элементы формы
  renderItems({ items, sectionsLen, itemsLen, rowCount, activeRow, isRow }) {
    const {
      activeSection,
      activeItem,
      errors,
      onActive,
      onChange,
      onCreateItem,
      onRemoveItem,
      onSortItem,
      onShowPanel,
    } = this.props;
    return items.map((item) => {
      if (item.class === 'row') {
        return (
          <div key={item.id} styleName="fe__row">
            {this.renderItems({
              items: item.items,
              sectionsLen,
              itemsLen,
              rowCount: item.rowCount,
              activeRow,
              isRow: true,
            })}
          </div>
        );
      }
      return (
        <BaseItem
          key={`${item.sectionIndex}_${item.itemIndex}`}
          activeSection={activeSection}
          activeItem={activeItem}
          activeRow={activeRow}
          onActive={onActive}
          onChange={onChange}
          onCreateItem={onCreateItem}
          onRemoveItem={onRemoveItem}
          onSortItem={onSortItem}
          onShowPanel={onShowPanel}
          rowCount={rowCount}
          sectionsLen={sectionsLen}
          itemsLen={itemsLen}
          rowItems={isRow ? items : undefined}
          errors={errors}
          {...item}
        />
      );
    });
  }

  renderSystemSection() {
    const { activeSection, activeItem, sections } = this.props;
    return (
      <>
        {['title', 'description'].map((item, index) => (
          <BaseItem
            key={`sys_${item}`}
            id={`sys_${item}`}
            itemIndex={index}
            sectionIndex={-1}
            activeSection={activeSection}
            activeItem={activeItem}
            onActive={() => {}}
            onChange={() => {}}
            onCreateItem={() => {}}
            onRemoveItem={() => {}}
            onSortItem={() => {}}
            onShowPanel={() => {}}
            rowCount={0}
            sectionsLen={sections.length}
            class="edit"
            placeholder={this.i(mes[item])}
          />
        ))}
      </>
    );
  }

  // Отрисовать секции
  renderSections(sections) {
    const {
      activeSection,
      activeItem,
      errorsChecked,
      onRemoveSection,
      onRenameSection,
      onSortSection,
      onCreateTemplate,
    } = this.props;
    const sectionsLen = sections.length;
    const selectedSection = sections[activeSection] || {};
    const selectedSectionContent = selectedSection.content || [];
    const activeItemModel = selectedSectionContent[activeItem] || {};
    const activeRow = activeItemModel.row;
    return sections.map((section, index) => {
      const items = this.setItemIndex(section.content || [], index);
      const itemsLen = items.length;
      const sectionItems = this.groupRowItems(items);
      const isLoop = typeof section.loop !== 'undefined';
      const isActive = activeSection === index;
      const sectionTitle = section.title || '';
      const titleFieldError = errorsChecked && !sectionTitle.length;
      return (
        <div key={index} styleName="fe__section">
          <div styleName="fe__section__header">
            <TextField
              styleName="fe__section__header__title"
              size="small"
              bordered={true}
              autoFocus={true}
              placeholder={this.i(mes.enterSectionTitle)}
              helperText={titleFieldError ? this.i(mes.fieldRequired) : null}
              error={titleFieldError}
              value={sectionTitle}
              onChange={({ value }) => onRenameSection(index, value)}
            />
            <div styleName="fe__section__header__var">
              <ToggleSwitch
                styleName="fe__section__header__var__switch"
                value={isLoop}
                onChange={onCreateTemplate}
                visibility={isActive ? 'visible' : 'disabled'}
              />
              <Label
                styleName="fe__section__header__var__label"
                value={this.i(mes.makeAsTemplate)}
              />
              {isLoop ? (
                <TextField
                  styleName="fe__section__header__var__field"
                  id="loop"
                  bordered={true}
                  size="small"
                  placeholder="{{VAR_NAME}}"
                  value={section.loop}
                  onChange={onCreateTemplate}
                  visibility={isActive ? 'visible' : 'disabled'}
                />
              ) : null}
            </div>
            <div styleName="fe__section__header__btns">
              <div styleName="fe__section__header__btns__nav">
                <Icon
                  type="arrow"
                  visibility={index !== 0 ? 'visible' : 'disabled'}
                  onClick={() => onSortSection(index, 'up')}
                />
                <Icon
                  type="arrow"
                  visibility={
                    index !== sectionsLen - 1 ? 'visible' : 'disabled'
                  }
                  onClick={() => onSortSection(index, 'down')}
                />
              </div>
              <div>
                <Icon type="trash" onClick={() => onRemoveSection(index)} />
              </div>
            </div>
          </div>
          <div styleName="fe__section__content">
            {this.renderItems({
              items: sectionItems,
              sectionsLen,
              itemsLen,
              rowCount: 0,
              activeRow,
              isRow: false,
            })}
          </div>
        </div>
      );
    });
  }

  render() {
    const { sections, onCreateSection, isTemplate } = this.props;
    return (
      <div styleName="fe">
        {isTemplate ? (
          <div styleName="fe__system">{this.renderSystemSection()}</div>
        ) : null}
        <div styleName="fe__sections">{this.renderSections(sections)}</div>
        <div styleName="fe__add" onClick={onCreateSection}>
          <div>{this.i(mes.addSection)}</div>
        </div>
      </div>
    );
  }
}

FormEdit.propTypes = {
  sections: PropTypes.array.isRequired,
  activeSection: PropTypes.number.isRequired,
  activeItem: PropTypes.number.isRequired,
  errors: PropTypes.object,
  isTemplate: PropTypes.bool,
  errorsChecked: PropTypes.bool,
  onActive: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onCreateSection: PropTypes.func.isRequired,
  onRemoveSection: PropTypes.func.isRequired,
  onSortSection: PropTypes.func.isRequired,
  onRenameSection: PropTypes.func.isRequired,
  onCreateItem: PropTypes.func.isRequired,
  onRemoveItem: PropTypes.func.isRequired,
  onSortItem: PropTypes.func.isRequired,
  onShowPanel: PropTypes.func.isRequired,
  onCreateTemplate: PropTypes.func.isRequired,
};

FormEdit.contextTypes = {
  intl: intlShape,
};

export default injectIntl(FormEdit);
